/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Dok_S3Inputs */

const en_tut_dok_s3 = /** @type {(inputs: Tut_Dok_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press **Simpan revisi** to mark a version. **Riwayat revisi** keeps the last 50, and **Pulihkan** brings an old one back as a new revision.`)
};

const id_tut_dok_s3 = /** @type {(inputs: Tut_Dok_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekan **Simpan revisi** untuk menandai versi. **Riwayat revisi** menyimpan 50 versi terakhir, dan **Pulihkan** mengembalikan versi lama sebagai revisi baru.`)
};

/**
* | output |
* | --- |
* | "Press **Simpan revisi** to mark a version. **Riwayat revisi** keeps the last 50, and **Pulihkan** brings an old one back as a new revision." |
*
* @param {Tut_Dok_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_dok_s3 = /** @type {((inputs?: Tut_Dok_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Dok_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_dok_s3(inputs)
	return en_tut_dok_s3(inputs)
});